// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__t0Bg2","detailsBorder":"styles_detailsBorder__3SKq9"};